
export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[85vh] sm:h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5c696a42387e87a6d44400ff1eb28746.jpg"
          alt="Tech Workshop"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-5 sm:px-6 max-w-4xl mx-auto">
        <div className="flex justify-center mb-6 sm:mb-8">
          <img
            src="https://static.readdy.ai/image/aa2ff2400bfafb6f4ad0dde7508c4a41/99519d97d87bafed31d0d8d3a2ef2c87.png"
            alt="Parker Family Tech Solutions"
            className="h-48 sm:h-56 md:h-64 w-auto object-contain"
          />
        </div>
        <p className="text-base sm:text-lg text-white/90 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed">
          Professional Computer Repair &amp; IT Services / Trusted by Local Families
        </p>
      </div>
    </section>
  );
}
